<template>
	<el-dialog title="" center :visible="mobile" @close="close" :close-on-click-modal="false">
		<span class="type_size_30 subject_color">{{phone?"更换手机号":"绑定手机号"}}</span>
		<div class="p_flex p_logins p_m_t_30 p_f_a">
			<span class="p_m_l_30 type_size_18 ">手机号</span>
			<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="number" maxlength="11" v-model="account" placeholder="请输入手机号"></el-input></div>
		</div>
		<div class="p_flex p_logins p_f_a p_m_t_30">
			<span class="p_m_l_30 type_size_18 ">验证码</span>
			<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="number" maxlength="6" v-model="password" placeholder="请输入验证码"></el-input></div>
			<div class="type_size_18 p_m_r_30 small_hand" :class="[countTimes == true ? 'subject_yellow' : 'yan_code forbid']" @click="verification">
				{{ countTimes == true ? '获取验证码' : seconds + 's后重新获取' }}
			</div>
		</div>
		<div class="p_flex p_f_c p_m_t_30" @click="goButton"><el-button type="success">确认</el-button></div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		mobile: null
	},
	data() {
		return {
			account: '',
			password: '',
			countTime: null,
			countTimes: true,
			seconds: 60,
			phone:""
		};
	},

	mounted() {
		var userInfo = JSON.parse(localStorage.getItem('user'));
		this.phone=userInfo.phone

	},
	methods: {
		close() {
			this.$emit('closesm', false);
		},
		goButton() {
			this.$request.ajax(this).post("/api/account_binding_phone",{
					phone:this.account,
					code:this.password
			}).then(res=>{
				// console.log(res)
				this.$request.ajax(this).post("/api/login_info").then(res=>{
						localStorage.setItem("user",JSON.stringify(res.data))
						this.$emit('goButtonm', false);
						this.$store.commit("statename",this.account)
						this.account=""
						this.password=""
						this.countTimes=true
						this.$router.go(0)
				})
			})
		},
		verification() {
			const thta = this;
			if (thta.account == '') {
				thta.$message.error('手机号不能为空');
				return;
			}
			thta.$request.ajax(this).post("/api/phone_code",{
				phone:this.account,
				code_type:"binding_phone"   //绑定手机号或更改手机号
			}).then(res=>{
				console.log(res)
			})
			thta.countTimes = false;
			thta.countDown();
		},
		countDown() {
			const thta = this;
			thta.countTime = setInterval(function() {
				thta.seconds--;
				if (thta.seconds == 0) {
					thta.countTimes = true;
					thta.seconds = 60;
					clearInterval(thta.countTime);
					thta.countTime = null;
					return;
				}
			}, 1000);
		},
	}
};
</script>

<style lang="scss" scoped>
.content_box {
	padding: 20px 0;
}
.subject_red {
	color: #f1282e;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}
.p_logins{
	height: 64px;
	background: #F5F5F5;
	opacity: 1;
	border-radius: 10px;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/user/commponents/mobile.vue